import { render, staticRenderFns } from "./InThePress.vue?vue&type=template&id=050b74bf&lang=pug&"
import script from "./InThePress.vue?vue&type=script&lang=js&"
export * from "./InThePress.vue?vue&type=script&lang=js&"
import style0 from "./InThePress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050b74bf')) {
      api.createRecord('050b74bf', component.options)
    } else {
      api.reload('050b74bf', component.options)
    }
    module.hot.accept("./InThePress.vue?vue&type=template&id=050b74bf&lang=pug&", function () {
      api.rerender('050b74bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/InThePress.vue"
export default component.exports